var ModalService = /** @class */ (function () {
    function ModalService() {
        this.modals = [];
    }
    ModalService.prototype.registerModal = function (newModal) {
        if (newModal && newModal.id) {
            var modal = this.findModal(newModal.id);
            // Delete existing to replace the modal
            if (modal) {
                this.modals.splice(this.modals.indexOf(modal));
            }
            this.modals.push(newModal);
        }
    };
    ModalService.prototype.open = function (id) {
        if (id) {
            var modal = this.findModal(id);
            if (modal) {
                modal.isOpen = true;
            }
        }
    };
    ModalService.prototype.close = function (modalId, checkBlocking) {
        if (checkBlocking === void 0) { checkBlocking = false; }
        var modal = this.findModal(modalId);
        if (modal && modal.isOpen) {
            if (checkBlocking && modal.blocking) {
                return;
            }
            modal.isOpen = false;
            modal.close();
        }
    };
    ModalService.prototype.findModal = function (modalId) {
        for (var _i = 0, _a = this.modals; _i < _a.length; _i++) {
            var modal = _a[_i];
            if (modal.id === modalId) {
                return modal;
            }
        }
        return null;
    };
    return ModalService;
}());
export { ModalService };
